// Offers
export const VALID_OFFER_STATUS_KEY = 'D';

// Invoices
export const OPEN_INVOICE_STATUS_KEY = 'O';

// LocalStorageKey
export const LOCAL_STORAGE_KEY = 'persisted-finance-machine-state';
